import { render } from "./LogisticsServicesPage.vue?vue&type=template&id=86a6827a&scoped=true"
import script from "./LogisticsServicesPage.vue?vue&type=script&lang=js"
export * from "./LogisticsServicesPage.vue?vue&type=script&lang=js"

import "./LogisticsServicesPage.vue?vue&type=style&index=0&id=86a6827a&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a6827a"]])

export default __exports__